import { api } from '@/apis';
import { log } from '@/utils';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useObjectiveFeatureCollection({ groupCodes = [] }) {
  const queryKey = ['objectiveFeatureCollection', groupCodes];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: async ({ signal }) => {
      const json = [
        { $match: { boundary: { $exists: true } } },
        {
          $graphLookup: {
            from: 'groups',
            startWith: '$groupCodes',
            connectFromField: 'parentCodes',
            connectToField: 'code',
            as: 'groups',
          },
        },
        groupCodes.length > 0 && {
          $match: { 'groups.code': { $in: groupCodes } },
        },
        {
          $project: {
            _id: false,
            type: 'Feature',
            id: '$identifier',
            geometry: '$boundary',
            properties: {
              identifier: '$identifier',
              title: '$title',
              occurrenceNumber: '$occurrenceNumber',
              attributes: '$attributes',
              contentHTML: '$contentHTML',
              startTime: '$startTime',
              endTime: '$endTime',
              schedule: '$schedule',
              microbeats: '$microbeats',
              requiredVisits: '$requiredVisits',
              requiredFrequency: '$requiredFrequency',
              complianceSeconds: '$complianceSeconds',
              resourceType: '$resourceType',
              personCodes: '$personCodes',
              vehicleIdentificationNumbers: '$vehicleIdentificationNumbers',
              personGroupCodes: '$personGroupCodes',
              vehicleGroupCodes: '$vehicleGroupCodes',
            },
          },
        },
        { $sort: { 'properties.title': 1 } },
      ].filter(Boolean);

      log('Read', 'Objective Feature Collection', { groupCodes });

      const features = await api
        .post('pipeline/objectives', { json, signal })
        .json();

      return {
        type: 'FeatureCollection',
        features,
      };
    },
    placeholderData: {
      type: 'FeatureCollection',
      features: [],
    },
    staleTime: 1000 * 60 * 60,
  });

  return {
    query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
